import { render, staticRenderFns } from "./imgM.vue?vue&type=template&id=36f08794"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36f08794')) {
      api.createRecord('36f08794', component.options)
    } else {
      api.reload('36f08794', component.options)
    }
    module.hot.accept("./imgM.vue?vue&type=template&id=36f08794", function () {
      api.rerender('36f08794', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgM.vue"
export default component.exports